import { FontAwesome5 } from '@expo/vector-icons';
import { styled } from '@openeducation/oe-rn-themes';
import * as React from 'react';
import { useTheme } from 'react-native-paper';

import { OEText, OETextProps } from '../oe-text/oe-text';

interface IconMessageProps {
  type: 'success' | 'warning';
}

const StyledOEText = styled(OEText)<IconMessageProps & OETextProps>`
  padding-top: 8px;
  width: 40px;
  height: 40px;
  border-radius: 20px;
  text-align: center;
  text-align-vertical: center;
  background-color: ${({ theme, type }) =>
    type === 'success' ? theme.color.primary : theme.color.accent};
`;

const iconContent = {
  success: 'check',
  warning: 'exclamation-triangle',
};

const IconMessage = ({ type }: IconMessageProps) => {
  const { colors } = useTheme();

  return (
    <StyledOEText type={type} color={colors.white}>
      <FontAwesome5 size={20} name={iconContent[type]} />
    </StyledOEText>
  );
};

export default IconMessage;
